<template>
  <div class="home">
    <b-container class="bv-example-row">
      <b-row>
        <b-col class="p-0 menu">
          <Menu />
        </b-col cols="12" md="auto">
        <b-col>
          <Header />

          <b-container class="dashboard-content">

            An error has occured, please try again later.<br />
            {{ this.$store.state.error }}<br />
            If this error persists, please contact <a href="mailto:mdcai@avconcepts.com">mdcai@avconcepts.com</a> for assistance.<br /><br />

          </b-container>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import Spinner from '@/components/Spinner.vue'

export default {
  name: 'dashboard', 
  data(){
    return {
        showSpinner: false,
        results: [
            {
                "id": "2",
                "email": "alok@alokw.com",
                "created": null,
                "used": "2022-03-31T03:22:23.188Z"
            },
            {
                "id": "3",
                "email": "alok+test1@alokw.com",
                "created": null,
                "used": "2022-03-31T16:14:25.014Z"
            }
        ]
      }
  },
  mounted() {
    this.showSpinner = true,
    this.$store.state.page = "Dashboard"
  },
  computed: {
    user () {
      return this.$store.state.user
      // { "logged": true, "loggedInAs": { "name": "Alok Wadhwani", "email": "alok@alokw.com" } }
    },
  },
  components: {
    Menu,
    Header,
    Spinner
  }
}
</script>
